import React from "react"
import CoreTransaction from "components/CoreTransaction"

const TransactionsScene = (): JSX.Element => {
  return <CoreTransaction />
}

export default TransactionsScene
